import Booking from "./booking";
export default Booking;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/index.ts
// module id = juIJ
// module chunks = 2